import { createRecipe } from './runtime';

const coverConfig = {"name":"cover","defaultVariants":{"plate":"1"},"variantMap":{"plate":["1","2","3","4"]}}

export const cover = /* @__PURE__ */ createRecipe(coverConfig)